import { getPersonalization } from '@nile/graphql';
import { getCurrentUserHook } from '@nile/components';
import { isEmpty } from 'lodash';
import { savePersonalization } from '@nile/graphql';
import { useState } from 'react';

let aiPersonalisationData = null;

const AIPersonalisationHook = () => {
  const currentUser = getCurrentUserHook();
  const [loading, setLoading] = useState(false);

  const getAIPersonalisation = async (user) => {
    if (!isEmpty(user?.userId)) {
      setLoading(true);
      const response = await getPersonalization({
        userId: user?.userId,
        name: 'ai-personalisation',
        category: user?.userId
      });
      setLoading(false);

      const data = response?.data?.getPersonalizationByCategoryAndName;

      if (!isEmpty(data)) {
        aiPersonalisationData = JSON.parse(data?.value);
      } else {
        return null;
      }
    }
  };

  const saveAIPersonalisation = (obj) => {
    if (!isEmpty(obj)) {
      const updatedData = !isEmpty(aiPersonalisationData)
        ? { ...aiPersonalisationData, ...obj }
        : { ...obj };

      const variables = {
        user: {
          firstName: currentUser?.firstName,
          userId: currentUser?.userId,
          email: currentUser?.email,
          lastName: currentUser?.lastName
        },
        name: 'ai-personalisation',
        category: currentUser?.userId,
        value: JSON.stringify(updatedData)
      };

      savePersonalization({
        variables: variables,
        input: variables
      }).then((res) => {
        if (res?.data?.savePersonalization) {
          aiPersonalisationData = updatedData;
        }
      });
    }
  };

  return {
    getAIPersonalisation,
    saveAIPersonalisation,
    aiPersonalisationData,
    loading
  };
};

export default AIPersonalisationHook;
